import { forwardRef } from "react";

const Input = forwardRef(
  ({ label, type = "text", name, value, onChange, error, className = "", ...props }, ref) => {
    return (
      <div>
        {label && (
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            {label}
          </label>
        )}
        <input
          ref={ref}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          className={`w-full px-3.5 py-2.5 bg-white border rounded-lg text-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 placeholder:text-gray-400 ${
            error ? "border-red-400 focus:ring-red-500/20 focus:border-red-500" : "border-gray-300 hover:border-gray-400"
          } ${className}`}
          {...props}
        />
        {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
